import { render, staticRenderFns } from "./expiredSubscription.vue?vue&type=template&id=3359ffa4"
import script from "./expiredSubscription.vue?vue&type=script&lang=js"
export * from "./expiredSubscription.vue?vue&type=script&lang=js"
import style0 from "./expiredSubscription.vue?vue&type=style&index=0&id=3359ffa4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports